export { default } from './styled';
